import { NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSidePropsContext } from "next";
import StrategyRS4_US from "components/pages/strategy/RS4_US";

interface Props {}

const StrategyRS4_USPage: NextPage<Props> = ({}) => {
  return <StrategyRS4_US />;
};
export default StrategyRS4_USPage;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  let locale = context.locale || context.defaultLocale || "ko";

  return {
    props: {
      ...(await serverSideTranslations(locale, ["strategy"])),
    },
  };
}
